/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * APIレスポンスのモデル基底
 * @export
 * @interface ResponseType
 */
export interface ResponseType {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseType
     */
    result: ResponseResult;
}

/**
 * Check if a given object implements the ResponseType interface.
 */
export function instanceOfResponseType(value: object): value is ResponseType {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function ResponseTypeFromJSON(json: any): ResponseType {
    return ResponseTypeFromJSONTyped(json, false);
}

export function ResponseTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseType {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
    };
}

export function ResponseTypeToJSON(json: any): ResponseType {
    return ResponseTypeToJSONTyped(json, false);
}

export function ResponseTypeToJSONTyped(value?: ResponseType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
    };
}

